module.exports = __webpack_public_path__ + "434f6b2ca23c68a517402aa60ef18491.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/school-girl-uniform-s.png
// module id = 1934
// module chunks = 0